function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { guid } from '@bydesign-ui/utils';
import { Emitter, DomNode } from '@bydesign-ui/hooks';
import { NestWatcher } from '../../../models/nest-watcher';
import { Validator } from '../../../models/validate';
import { getNestCachePath, getNestWatchPath, getRelativeKeys } from '../util';
import { FormNodeType } from '../types';
export var FormField = function (_Emitter) {
  _inherits(FormField, _Emitter);

  var _super = _createSuper(FormField);

  function FormField(form, scope, options) {
    var _this;

    _classCallCheck(this, FormField);

    _this = _super.call(this);
    _this.id = guid();
    _this.validator = new Validator(_assertThisInitialized(_this));
    var defaultValue = options.defaultValue,
        field = options.field,
        label = options.label,
        initialValue = options.initialValue;
    _this.form = form;
    _this.node = new DomNode({
      type: FormNodeType.FIELD,
      field: field,
      id: _this.id
    }, scope);
    _this.field = field;

    var cacheValue = _this.getCacheValue();

    _this.label = label || field;
    _this.initialValue = initialValue;
    _this.defaultValue = defaultValue;
    _this.initialState = true;
    _this.value = cacheValue != null ? cacheValue : defaultValue == null ? initialValue : defaultValue;

    _this.init();

    return _this;
  }

  _createClass(FormField, [{
    key: "updateOptions",
    value: function updateOptions(options) {
      var field = options.field,
          label = options.label,
          rules = options.rules,
          defaultValue = options.defaultValue;

      if (field !== this.field) {
        throw new Error('field should not be updated');
      }

      this.label = label || field;
      this.defaultValue = defaultValue;
      this.validator.updateRules(Array.isArray(rules) ? rules : rules != null ? [rules] : []);
    }
  }, {
    key: "isField",
    value: function isField() {
      return true;
    }
  }, {
    key: "isGroup",
    value: function isGroup() {
      return false;
    }
  }, {
    key: "isRepeat",
    value: function isRepeat() {
      return false;
    }
  }, {
    key: "getFieldInfo",
    value: function getFieldInfo() {
      return _objectSpread({
        field: this.field,
        value: this.value,
        label: this.label,
        path: this.getPath()
      }, this.validator.getValidateInfo());
    }
  }, {
    key: "getValidateError",
    value: function getValidateError() {
      return {
        label: this.label,
        field: this.field,
        error: this.validator.getValidateInfo().msg,
        value: this.value,
        path: this.getPath()
      };
    }
  }, {
    key: "reset",
    value: function reset() {
      this.validator.reset();
      this.form.setPathValue(NestWatcher.combineKeys(getRelativeKeys(this.node)), this.defaultValue == null ? this.initialValue : this.defaultValue, false, {
        reset: true
      });
    }
  }, {
    key: "getInitialState",
    value: function getInitialState() {
      return this.initialState;
    }
  }, {
    key: "validate",
    value: function validate() {
      var trigger = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'manual';
      this.validator.updateValue(this.value);
      return this.validator.validate(trigger);
    }
  }, {
    key: "getByExpression",
    value: function getByExpression(rp) {
      if (!/^\./.test(rp)) {
        return this.form.getPathValue(rp);
      }

      var path = NestWatcher.splitKey(this.getPath());
      path.pop();

      while (/^(\.\.\/)/.test(rp)) {
        rp = rp.slice(RegExp.$1.length);
        path.pop();
      }

      if (/^(\.\/)/.test(rp)) {
        rp = rp.slice(RegExp.$1.length);
      }

      return this.form.getPathValue(NestWatcher.combineKeys([].concat(_toConsumableArray(path), _toConsumableArray(NestWatcher.splitKey(rp)))));
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.form.unregister(this);
      this.form.unwatch(this.id);
      this.validator.dispose();

      if (this.form.getSaveMemCache()) {
        this.setCacheValue();
      } else {
        this.form.deletePathValue(NestWatcher.combineKeys(getRelativeKeys(this.node)));
      }

      this.node.remove();
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.value;
    }
  }, {
    key: "setValue",
    value: function setValue(value) {
      this.form.setPathValue(NestWatcher.combineKeys(getRelativeKeys(this.node)), value);
      this.validator.updateValue(value, true);
    }
  }, {
    key: "getForm",
    value: function getForm() {
      return this.form;
    }
  }, {
    key: "getNode",
    value: function getNode() {
      return this.node;
    }
  }, {
    key: "getPath",
    value: function getPath() {
      return NestWatcher.combineKeys(getRelativeKeys(this.node));
    }
  }, {
    key: "init",
    value: function init() {
      var _this2 = this;

      this.form.register(this);
      var value = this.form.getPathValue(this.getPath());

      if (value != null) {
        this.value = value;
      } else {
        this.form.setPathValue(this.getPath(), this.value, true);
      }

      this.validator.updateValue(this.value, false);
      this.form.absoluteWatch(this.id, [NestWatcher.combineKeys(getNestWatchPath(this.node))], function (paths, flags) {
        return new Promise(function (resolve) {
          setTimeout(function () {
            var onv = _this2.form.getPathValue(_this2.getPath());

            var nv = onv === undefined ? _this2.initialValue : onv;
            var isNeedUpdate = nv !== _this2.value;

            if (Array.isArray(nv) && Array.isArray(_this2.value) && nv.length === _this2.value.length && nv.length === 0 && !(flags && flags.reset)) {
              isNeedUpdate = false;
            }

            if (isNeedUpdate) {
              _this2.value = nv;
              _this2.initialState = false;

              if (flags && flags.reset) {
                _this2.initialState = true;

                _this2.validator.reset();

                resolve(_this2.value);
              } else {
                _this2.emit('repaint');

                resolve(_this2.validate('change'));
              }
            }
          }, 0);
        });
      });
      this.validator.addListener('change', function (result) {
        _this2.form.dispatchValidateResult(_this2.id, _this2.node, result);

        _this2.emit('repaint');
      });
    }
  }, {
    key: "getCache",
    value: function getCache() {
      var node = this.node.parentNode;

      while (node) {
        var _node$getValue = node.getValue(),
            cache = _node$getValue.cache;

        if (cache) {
          return cache;
        }

        node = node.parentNode;
      }

      return null;
    }
  }, {
    key: "setCacheValue",
    value: function setCacheValue() {
      var cache = this.getCache();
      var cachePath = NestWatcher.combineKeys(getNestCachePath(this.node));

      if (cache && cachePath) {
        cache.addCache(cachePath, this.value);
      }
    }
  }, {
    key: "getCacheValue",
    value: function getCacheValue() {
      var cache = this.getCache();
      var cachePath = NestWatcher.combineKeys(getNestCachePath(this.node));

      if (cache && cachePath) {
        var cacheValue = cache.getCache(cachePath);

        if (cacheValue != null) {
          return cacheValue;
        }
      }

      return null;
    }
  }]);

  return FormField;
}(Emitter);